import { CalendarDataState, CalendarState } from './types';

export const INITIAL_CALENDAR_DATA_STATE: CalendarDataState = {
  oamCalendar: null,
  sessionId: null,
  sessionIdTimestamp: null,
};

export const INITIAL_CALENDAR_STATE: CalendarState = {
  ...INITIAL_CALENDAR_DATA_STATE,
  oamCalendarLoading: false,
  oamCalendarError: null,
  oamCalendarSuccess: null,
  sessionIdLoading: false,
  sessionIdError: null,
  sessionIdSuccess: null,
  sessionIdTimestampLoading: false,
  sessionIdTimestampError: null,
  sessionIdTimestampSuccess: null,
};
